import { useQuery } from "@tanstack/react-query";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import signalEventsService from "../services/signals/signalEventsService";

import { companyAnalysisQueryKeys } from "./queryKeyFactory";

const useSignalsEventsQuery = (options?: { take?: number; enabled?: boolean }) => {
    const { enabled = true, take } = options || {};
    const {
        params: { key: domain },
    } = useCurrentStateAndParamsWithFixedDomain();

    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: companyAnalysisQueryKeys.signalEvents(domain, take),
        queryFn: async ({ signal }) => {
            const data = await salesApiService.companyAnalysis.fetchSignalEvents(
                {
                    domain,
                    take,
                },
                { cancellation: signal },
            );
            return signalEventsService.getValidSignalEvents(data);
        },
        enabled: enabled && Boolean(domain),
    });
};

export default useSignalsEventsQuery;
